export const inventionTypeOptions = [
  { label: "Patente", value: "PATENT" },
  { label: "Modelo de utilidad", value: "UTILITY_MODEL" },
  { label: "Diseño industrial", value: "INDUSTRIAL_DESIGN" },
  { label: "No aplica", value: "DOESNT_APPLY" }
];